<template>
  <div>
    <v-dialog v-model="showDialog" persistent max-width="600">
      <v-card class="pa-3">
        <v-card-title class="pb-0">
          <div class="title font-weight-bold mx-auto">Alterar plano da UC</div>
        </v-card-title>
        <v-card-text class="mx-auto py-0">
          <v-flex xs12 md12 class="mx-auto d-flex justify-center">
            <v-list-tile class="plan_details">
              <v-list-tile-content class="mx-auto d-flex justify-center">
                <v-list-tile-sub-title class="dynamic_width"
                  >Plano Vigente</v-list-tile-sub-title
                >
                <v-list-tile-title
                  v-if="this.consumer_unit.plan?.contract_time > 0"
                  class="dynamic_width"
                >
                  {{
                    this.consumer_unit.plan?.name || this.consumer_unit.plan?.id
                  }}
                  | Tempo de contrato:
                  {{ this.consumer_unit.plan?.contract_time }} meses
                </v-list-tile-title>
                <v-list-tile-title v-else class="dynamic_width">
                  {{
                    this.consumer_unit.plan?.name || this.consumer_unit.plan?.id
                  }}
                </v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
          </v-flex>
          <v-row class="mx-auto d-flex justify-center">
            <v-col xs12 md12 class="mx-auto d-flex justify-center">
              <v-checkbox
                v-model="existingPlan"
                class="dynamic_width"
                label="Adicionar plano existente"
              ></v-checkbox>
            </v-col>
            <v-col xs12 md12 class="mx-auto d-flex justify-center">
              <v-checkbox
                v-model="onTimePayment"
                class="dynamic_width"
                label="Pagamento em dia?"
                :disabled="existingPlan"
              ></v-checkbox>
            </v-col>
            <v-col xs12 md12 class="mx-auto d-flex justify-center">
              <v-checkbox
                v-if="hasFidelity"
                v-model="noFidelity"
                class="dynamic_width"
                label="Sem Fidelidade"
              ></v-checkbox>
            </v-col>
          </v-row>
          <transition name="slide-fade">
            <v-flex v-show="existingPlan" xs12 md12 class="px-5 mx-5">
              <v-form ref="existing_plan" v-model="valid" lazy-validation>
                <v-layout v-if="!noFidelity" row align-center>
                  <v-text-field
                    label="Fidelidade (meses)"
                    v-model="fidelidade"
                    type="number"
                    required
                    :rules="fidelidadeRules"
                    :disabled="noFidelity"
                  />
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon
                        v-on="on"
                        color="grey"
                        style="font-size: 16px; cursor: pointer"
                      >
                        mdi-help-circle
                      </v-icon>
                    </template>
                    <span
                      >A fidelidade deve ser maior ou igual ao tempo restante
                      para encerrar a fidelidade do contrato atual. Se o período
                      de fidelidade já expirou ou se o plano atual não possuir
                      fidelidade, a negociação pode contemplar um novo plano sem
                      fidelidade.</span
                    >
                  </v-tooltip>
                </v-layout>
                <v-select
                  label="Plano"
                  v-model="plan"
                  :items="plans"
                  :item-text="formattedPlanText"
                  item-value="id"
                  return-object
                  required
                  :rules="planRules"
                />
                <v-select
                  label="Motivo"
                  v-model="reason"
                  :items="reasons"
                  item-text="name"
                  item-value="id"
                  :rules="reasonRules"
                  required
                  return-object
                />
                <v-text-field
                  label="Descrição Adicional"
                  v-model="additional_description"
                  :rules="descriptionRules"
                  required
                />
              </v-form>
            </v-flex>
          </transition>
          <transition name="slide-fade">
            <v-flex v-show="!existingPlan" xs12 md12 class="px-5 mx-5">
              <v-form ref="speacial_plan" v-model="valid" lazy-validation>
                <v-layout v-if="!noFidelity" row align-center>
                  <v-text-field
                    label="Fidelidade (meses)"
                    v-model="fidelidade"
                    type="number"
                    required
                    :rules="fidelidadeRules"
                    :disabled="noFidelity"
                  />
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon
                        v-on="on"
                        color="grey"
                        style="font-size: 16px; cursor: pointer"
                      >
                        mdi-help-circle
                      </v-icon>
                    </template>
                    <span
                      >A fidelidade deve ser maior ou igual ao tempo restante
                      para encerrar a fidelidade do contrato atual. Se o período
                      de fidelidade já expirou ou se o plano atual não possuir
                      fidelidade, a negociação pode contemplar um novo plano sem
                      fidelidade.</span
                    >
                  </v-tooltip>
                </v-layout>
                <v-text-field
                  v-model="discount"
                  label="Desconto (%)"
                  type="number"
                  class="pt-0"
                  @keydown="preventNumberChange"
                  required
                  :rules="percentageDiscountRules()"
                  @change="formatNumber(discount)"
                ></v-text-field>
                <v-select
                  label="Motivo"
                  v-model="reason"
                  :items="reasons"
                  item-text="name"
                  item-value="id"
                  :rules="reasonRules"
                  required
                  return-object
                />
                <v-text-field
                  label="Descrição Adicional"
                  v-model="additional_description"
                  :rules="descriptionRules"
                  required
                />
              </v-form>
            </v-flex>
          </transition>
        </v-card-text>
        <v-card-actions>
          <div class="mx-auto">
            <v-btn
              color="primary"
              text
              @click="showDialog = false"
              :disabled="loading"
              >Fechar</v-btn
            >
            <v-btn
              color="pink darken-1"
              text
              @click="confirm"
              :loading="loading"
              :disabled="!isFormValid"
              >Confirmar</v-btn
            >
          </div>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-snackbar :color="color" top v-model="snackbar" dark>
      <v-icon color="white" class="mr-3"> mdi-bell-plus </v-icon>
      <div>{{ snackMessage }}</div>
      <v-icon size="16" @click="snackbar = false"> mdi-close-circle </v-icon>
    </v-snackbar>
  </div>
</template>
<script>
import moment from "moment";
import { mapGetters, mapState } from "vuex";
import firestore from "../../firebase/firestore";
import { updateConsumerUnit } from "../../services/consumer_units";
import { getPermission } from "../../services/permissions";
import { addPlansFb, findPlanFb } from "../../services/plans";
export default {
  props: {
    consumer_unit: {
      type: Object,
      required: false,
    },
    user: {
      type: Object,
      required: false,
    },
  },
  data() {
    return {
      valid: false,
      existingPlan: false,
      onTimePayment: false,
      loading: false,
      showDialog: false,
      plans: [],
      plan: null,
      discount: null,
      fidelidade: null,
      contract_time: null,
      contract_times: [
        {
          time: 0,
          name: "Sem Fidelidade",
        },
        {
          time: 12,
          name: "12 meses",
        },
        {
          time: 24,
          name: "24 meses",
        },
      ],
      reason: null,
      reasons: [
        {
          id: "sales_error",
          name: "Erro na venda",
        },
        {
          id: "retention",
          name: "Retenção",
        },
        {
          id: "reactivation",
          name: "Reativação",
        },
      ],
      additional_description: "",
      contractTimeRules: [(v) => !!v || "Por favor, informe a fidelidade."],
      planRules: [(v) => !!v || "Por favor, informe o plano."],
      reasonRules: [(v) => !!v || "Por favor, informe o motivo."],
      descriptionRules: [
        (v) => !!v || "Por favor, descreva o motivo com mais detalhes.",
      ],
      fidelidadeRules: [
        (v) => !!v || "Por favor, informe a fidelidade.",
        (v) =>
          v >= this.minimumFidelityMonths ||
          `A fidelidade deve ser maior ou igual a ${this.minimumFidelityMonths} meses.`,
      ],
      color: "",
      snackMessage: "",
      snackbar: false,
      chosenPlan: {},
      canceled_clause: null,
      noFidelity: false,
    };
  },

  computed: {
    ...mapGetters("sales", ["filteredPlans"]),
    ...mapGetters(["loggedUser"]),
    ...mapState(["permissions"]),

    hasFidelity() {
      const plans_no_fidelity = [
        "cpfl-piratininga_semfidelidade10pf",
        "neo_semfidelidade10pf",
        "semfidelidade10pf",
        "semfidelidade10pj",
      ];
      const plan_id = this.consumer_unit?.plan?.id;
      if (plans_no_fidelity.includes(plan_id)) return false;
      else return true;
    },

    isFormValid() {
      return (
        this.valid &&
        ((this.existingPlan && this.plan) || !this.existingPlan) &&
        this.reason &&
        this.additional_description &&
        (this.noFidelity || this.fidelidade)
      );
    },

    minimumFidelityMonths() {
      if (
        !this.consumer_unit.plan?.contract_time ||
        !this.consumer_unit.contract_signed_at
      ) {
        return 0;
      }
      const contract_signed_at = moment(
        this.consumer_unit.contract_signed_at.toMillis(),
      );
      const contract_time = this.consumer_unit.plan.contract_time;
      const current_date = moment();
      const months_elapsed = current_date.diff(contract_signed_at, "months");
      return Math.max(contract_time - months_elapsed, 0);
    },
  },

  watch: {
    showDialog(newVal) {
      if (newVal) {
        this.fidelidade = this.minimumFidelityMonths;
      }
    },
  },

  methods: {
    async showModal(plan) {
      try {
        this.plans = plan;
        this.showDialog = true;
      } catch (err) {
        console.log("error showModal: ", err);
      }
    },

    async confirm() {
      this.loading = true;

      try {
        const permission = await getPermission(
          "change_plan_uc",
          this.loggedUser.id,
        );

        if (!permission.data.has_permission) {
          this.snack("Usuário sem permissão para realizar essa ação", "red");
          this.loading = false;
          return false;
        }
      } catch (err) {
        this.loading = false;
        this.snack("Falha ao consultar permissão do usuário", "red");
        console.error("Falha ao consultar permissão", err);
        return false;
      }
      if (this.consumer_unit.plan_already_changed) {
        this.loading = false;
        return this.$emit(
          "showSnack",
          "Esta UC já teve o plano alterado!",
          "red",
        );
      }
      if (this.existingPlan) {
        if (this.$refs.existing_plan.validate()) {
          this.chosenPlan = this.plan;

          if (this.chosenPlan?.id == this.consumer_unit?.plan?.id) {
            this.snack("A UC já possui o plano selecionado!", "red");
            this.loading = false;
            return;
          }
          this.canceled_clause =
            this.plan?.cancelation_conditions?.contract_canceled_clause;
          const fields = {
            change_plan_agent: this.loggedUser.email,
            change_plan_at: new Date(),
            percentage_discount: this.plan.discount,
            plan: {
              contract_time: this.plan.contract_time,
              discount: this.plan.discount,
              id: this.plan.id,
              name: this.plan.name,
              person_type: this.plan.person_type,
            },
            reason_change_plan: {
              reason: this.reason.name,
              description: this.additional_description,
            },
            generateContract: true,
            plan_already_changed: true,
            updated_at: new Date(),
          };
          try {
            await updateConsumerUnit(this.consumer_unit?.id, fields);
            this.loading = false;
          } catch (err) {
            console.error(err);
            this.snack("Erro ao alterar plano da UC", "red");
            this.loading = false;
            return;
          }
        } else {
          this.snack("Informe o plano para prosseguir", "red");
          this.loading = false;
          return;
        }
      } else {
        if (this.$refs.speacial_plan.validate()) {
          const plan_id = `custom_${this.fidelidade}meses_${this.discount}%_${this.onTimePayment ? "em_dia" : ""}`;

          this.chosenPlan = {
            contract_time: parseFloat(this.fidelidade),
            discount: parseFloat(this.discount),
            id: plan_id,
            name: "Plano Personalizado",
            person_type: this.consumer_unit?.person_type,
          };

          if (
            this.chosenPlan?.discount == this.consumer_unit?.plan?.discount &&
            this.chosenPlan?.contract_time ==
              this.consumer_unit?.plan?.contract_time
          ) {
            this.snack("A UC já possui o plano selecionado!", "red");
            this.loading = false;
            return;
          }

          const canceled_clauses = (
            await firestore
              .collection("config")
              .doc("specialPlansCanceledClause")
              .get()
          ).data();
          this.canceled_clause = canceled_clauses[this.fidelidade];
          const fields = {
            change_plan_agent: this.loggedUser.email,
            change_plan_at: new Date(),
            percentage_discount: parseFloat(this.discount),
            plan: this.chosenPlan,
            reason_change_plan: {
              reason: this.reason.name,
              description: this.additional_description,
            },
            generateContract: true,
            plan_already_changed: true,
            updated_at: new Date(),
          };

          const planAlreadyExist = (await findPlanFb(plan_id)).exists;

          if (!planAlreadyExist) {
            try {
              await addPlansFb(plan_id, {
                cancelation_conditions: {
                  contract_canceled_clause: this.canceled_clause,
                },
                contract_time: parseFloat(this.fidelidade),
                discount: parseFloat(this.discount),
                id: plan_id,
                name: `Plano Personalizado ${this.fidelidade} meses - ${this.discount}% OFF`,
                person_type: this.consumer_unit?.person_type,
                losesDiscountOnLatePayment: this.onTimePayment,
              });
            } catch (err) {
              console.error(err);
              this.snack("Erro ao criar plano especial", "red");
              this.loading = false;
              return;
            }
          }
          try {
            await updateConsumerUnit(this.consumer_unit?.id, fields);
            this.loading = false;
          } catch (err) {
            console.error(err);
            this.snack("Erro ao alterar plano da UC", "red");
            this.loading = false;
            return;
          }
        } else {
          this.snack("Preencha todos os campos", "red");
          this.loading = false;
          return;
        }
      }
      this.loading = false;
      this.showDialog = false;
      this.resetStates();
      this.$emit("showSnack", "Plano alterado com sucesso!", "green");
    },
    formattedPlanText(item) {
      return item.name + " " + item.person_type + " - " + item.discount + "%";
    },
    preventNumberChange(event) {
      if (event.key === "ArrowUp" || event.key === "ArrowDown") {
        event.preventDefault();
      }
    },
    formatNumber(number) {
      this.discount = parseFloat(number).toFixed(0);
    },
    resetStates() {
      this.plan = null;
      this.discount = null;
      this.contract_time = null;
      this.existingPlan = true;
      this.chosenPlan = null;
    },
    snack(message, color) {
      this.color = color;
      this.snackMessage = message;
      this.snackbar = true;
    },
    percentageDiscountRules() {
      const group = this.loggedUser.group;
      const sales_management = group.includes("sales_management");
      const customer_care_leader = group.includes("customer_care_leader");
      const board = group.includes("board");
      if (sales_management || customer_care_leader) {
        return [
          (v) => !!v || "Por favor, informe o desconto.",
          (v) =>
            v <= this.consumer_unit.plan.discount + 2 ||
            `Só é possível aumentar o desconto até ${
              this.consumer_unit.plan.discount + 2
            }%`,
        ];
      } else if (board) {
        return [
          (v) => !!v || "Por favor, informe o desconto.",
          (v) =>
            v <= this.consumer_unit.plan.discount + 4 ||
            `Só é possível aumentar o desconto até ${
              this.consumer_unit.plan.discount + 4
            }%`,
        ];
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.plan_details {
  display: flex !important;
  justify-content: center !important;
}
.slide-fade-enter-active {
  transition: all 0.4s ease;
}

.slide-fade-enter {
  transform: translateY(10px);
  opacity: 0;
}

.dynamic_width {
  max-width: fit-content !important;
}
::v-deep input::-webkit-outer-spin-button,
::v-deep input::-webkit-inner-spin-button {
  -webkit-appearance: none !important;
  margin: 0 !important;
}
</style>
